const canvas = document.createElement('canvas');
document.body.appendChild(canvas);
const ctx = canvas.getContext('2d');

canvas.width = window.innerWidth;
canvas.height = window.innerHeight;

const characters =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ'.split(
    '',
  );
const colors = ['#0F0', '#0F0', '#0F0', '#BF00FF', '#F00', '#0FF', '#F0F', '#FF0'];

const font_size = 10;
const columns = canvas.width / font_size;

const drops: number[] = [];
const columnColors: string[] = [];
for (let x = 0; x < columns; x++) {
  drops[x] = Math.floor(canvas.height / font_size) + 1;
  columnColors[x] = colors[Math.floor(Math.random() * colors.length)];
}

let frame_count = 0;
// The FRAME_RESET_THRESHOLD determines how often the canvas is completely cleared.
// This prevents the background from becoming completely solid over time due to the
// semi-transparent overlay in the draw function.
//
// Calculation:
// Desired clear frequency (in seconds) / (setInterval delay / 1000)
//
// Example: To clear every 10 minutes (600 seconds), with setInterval at 100ms (0.1s):
// 600 / 0.1 = 6000
const FRAME_RESET_THRESHOLD = 6000;

function draw() {
  if (frame_count > FRAME_RESET_THRESHOLD) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    frame_count = 0;
  }
  ctx.fillStyle = 'rgba(20, 20, 20, 0.05)';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.font = font_size + 'px arial';

  for (let i = 0; i < drops.length; i++) {
    const text = characters[Math.floor(Math.random() * characters.length)];
    ctx.fillStyle = columnColors[i];
    ctx.fillText(text, i * font_size, drops[i] * font_size);

    if (drops[i] * font_size > canvas.height && Math.random() > 0.999) {
      drops[i] = 0;
      columnColors[i] = colors[Math.floor(Math.random() * colors.length)];
    }

    drops[i]++;
  }
  frame_count++;
}

export function startMatrix(): number {
  return setInterval(draw, 100) as unknown as number;
}

export function stopMatrix(intervalId: number) {
  clearInterval(intervalId);
  const canvas = document.querySelector('canvas');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
}
